export default __webpack_public_path__ + "static/media/22.1d5858be.jpg";